module.exports = __webpack_public_path__ + "img/bind-success-icon.20faa57d.png";